// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fbb7c992","455":"feb14957"}[chunkId] + ".chunk.js";
};